import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class BookmarkedOrganisationsService extends RestfulService<Models.BookmarkedOrganisations> {

  constructor(private restService: RestService) {
    super(Models.BookmarkedOrganisations);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('bookmarked-organisations');
  }
}

